namespace GeniuzPOS.Lookups {
    export namespace SysParaService {
        export const baseUrl = 'Lookups/SysPara';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<SysParaRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<SysParaRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Lookups/SysPara/Retrieve",
            List = "Lookups/SysPara/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>SysParaService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
